import { Component, Input, ViewChildren, QueryList } from '@angular/core';

import { NavigationItem } from '@cigna/chcp/shared/util';
import { HoverDropdownDirective } from '@cigna/chcp/shared/ui';
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { RouterFacade } from '@cigna/core/router-state';
import { skip, filter } from 'rxjs/operators';

@Component({
  selector: 'cigna-primary-nav',
  templateUrl: './primary-nav.component.html',
  styleUrls: ['./primary-nav.component.scss'],
})
export class PrimaryNavComponent {
  @Input() links: NavigationItem[] = [];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() impersonator = false;

  @ViewChildren(HoverDropdownDirective)
  dropdownList: QueryList<HoverDropdownDirective>;

  constructor(private routerFacade: RouterFacade) {
    this.routerFacade.url$
      .pipe(
        skip(1),
        filter(() => this.dropdownList && this.dropdownList.length > 0),
      )
      .subscribe(() =>
        this.dropdownList.forEach((d) => d.open && d.onFocusOut()),
      );
  }
}
